var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinusOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "minus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.695,
    height: 24.699,
    viewBox: "0 0 24.695 24.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_19",
    "data-name": "Union 19",
    d: "M12940.683,20110.352a12.348,12.348,0,1,1,12.348,12.348A12.363,12.363,0,0,1,12940.683,20110.352Zm1.914,0a10.436,10.436,0,1,0,10.434-10.437A10.447,10.447,0,0,0,12942.6,20110.352Zm5.46.91a1,1,0,1,1,0-1.99H12958a1,1,0,1,1,0,1.99Z",
    transform: "translate(-12940.683 -20098)",
    fill: "#d9d9d9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusOff);
export default __webpack_public_path__ + "static/media/minus-off.a0c071c14d4ff6addbab06691b4798de.svg";
export { ForwardRef as ReactComponent };